import { FormService } from '../services'

export default () => {
  return new Promise((resolve) => {
    FormService.getCountriesCode()
      .then(response => resolve(response.data))
      .catch(err => console.log(err))
  })
}